__turbopack_context__.v({
  "button": "FundraisingEventTeamList-module__iEw5_W__button",
  "container": "FundraisingEventTeamList-module__iEw5_W__container",
  "imgContainer": "FundraisingEventTeamList-module__iEw5_W__imgContainer",
  "link": "FundraisingEventTeamList-module__iEw5_W__link",
  "listContainer": "FundraisingEventTeamList-module__iEw5_W__listContainer",
});
